import { environment } from '@/constants';

export function throwError(message, { warn = false } = {}) {
  if (environment === 'production') {
    return;
  }

  if (warn) {
    console.warn(message);
  } else {
    throw new Error(message);
  }
}

export function assert(condition, message, { warn = false } = {}) {
  if (condition) {
    return;
  }

  message = message || 'Assertion failed';

  throwError(message, { warn });
}
